import { useSelector } from 'react-redux';

import { UnleashFeatureNames } from '../../modules/Unleash/featureNames';
import { getIsFeatureEnabled } from '../../selectors/features';
import { useGetSessionCompany } from './useGetSessionCompany';

const ALLOWED_UNVERIFIED_COMPANY_POST_JOB_COUNTRIES = ['SG', 'MY'];

export const canUnverifiedCompanyPostJobs = ({
  countryCode,
  isFeatureEnabled,
}: {
  countryCode?: string | null;
  isFeatureEnabled: boolean;
}) =>
  Boolean(
    isFeatureEnabled &&
      countryCode &&
      ALLOWED_UNVERIFIED_COMPANY_POST_JOB_COUNTRIES.includes(
        countryCode.toUpperCase()
      )
  );

export default function useCanUnverifiedCompanyPostJobs(): boolean {
  const { sessionCompany } = useGetSessionCompany();
  const isFeatureEnabled = useSelector(state =>
    getIsFeatureEnabled(
      state,
      UnleashFeatureNames.empAllUnverifiedCompaniesSgMyPostJobs
    )
  );

  return canUnverifiedCompanyPostJobs({
    countryCode: sessionCompany?.CountryCode,
    isFeatureEnabled,
  });
}
